module.exports = __webpack_public_path__ + "static/img/18.005f60a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/11/18.png
// module id = sxam
// module chunks = 0